module.exports = __webpack_public_path__ + "static/media/nilza-menor.f9f56e8f.png";